import { React, PT } from '@gasbuddy/react';
import { Grid } from 'semantic-ui-react';
import { BrandLogo, BrandDescription } from '..';

export const BrandInfo = ({ brand }) => (
  <Grid columns={2} textAlign="center">
    <Grid.Row>
      <Grid.Column width={1}>
        <BrandLogo brand={brand} size="Large" />
      </Grid.Column>
      <Grid.Column width={1}>
        <h1>{brand.name}</h1>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={4}>
        <BrandDescription brand={brand} />
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

BrandInfo.defaultProps = {
  brand: {
    brandId: null,
    imageUrl: '',
    name: 'Unknown',
  },
};

BrandInfo.propTypes = {
  brand: PT.shape(
    {
      brand_id: PT.number,
      name: PT.string,
      logo_version: PT.number,
      is_cstore: PT.boolean,
      is_fuel: PT.boolean,
      allow_brand_sharing: PT.boolean,
    },
  ),
};
